import { useFormikContext } from "formik";
import { CADataPoints } from "../models/flexible/ca-data-points";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { getFlatPreparationsIfExist, getScopePreparations } from "../utils/agreement-utils";
import { anyNamedEntity } from "../utils/any-named-entity";
import { distinctBy } from "../utils/distinct-by";
import { useScopes } from "./useScopes";

export const useAvailableTreatmentPacks = (controller: FlexSectionController) => {
	const { selectedScopes } = useScopes(controller.context);
	const { values } = useFormikContext();
	const baseDataPoints = (controller.context.startingPoint?.data || values) as unknown as CADataPoints;
	const preparationDataPoints = getFlatPreparationsIfExist(baseDataPoints);

	return preparationDataPoints
		? distinctBy(
				selectedScopes
					.flatMap((scope) =>
						getScopePreparations(scope, (treatmentSet) =>
							preparationDataPoints.some((preparation) => treatmentSet.generic?.Name === preparation.genericName?.Name)
						)
					)
					.filter((enrollingPreparation) =>
						preparationDataPoints.some(
							(preparation) =>
								preparation.brandName?.Name === anyNamedEntity?.Name ||
								preparation.brandName?.Name === enrollingPreparation.BrandName
						)
					),
				(p) => p.id
		  )
		: distinctBy(
				selectedScopes
					.flatMap((scope) => scope.treatmentSets)
					.flatMap((treatmentSet) =>
						treatmentSet.preparations.length ? treatmentSet.preparations : treatmentSet.generic.preparations
					),
				(p) => p.id
		  );
};
